import React, { useState, useEffect } from "react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  Card,
  Button,
  Col,
  Spinner,
  Modal,
  Row,
  Container,
} from "react-bootstrap";
import { getToken } from "../../../utils/auth";

function AllQRHero() {
  const [allQR, setAllQR] = useState([]);
  const { t } = useTranslation();
  const [fetching, setFetching] = useState(false);
  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState("");

  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
  };

  const closeQrPopup = () => {
    setQrPopupOpen(false);
  };

  const fetchReservations = async () => {
    setFetching(true);
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/qrc/social-net/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setAllQR(response.data?.data || []);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to fetch QR Hero.");
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchReservations();
  }, []);

  const formatCategory = (category) => {
    if (category === "file") return "File";
    if (category === "v-card") return "vCard";
    if (category === "url") return "URL";
    return category || "N/A";
  };

  return (
    <Container fluid>
      <Toaster />
      <Col lg={12}>
        {fetching ? (
          <div className="d-flex justify-content-center mt-4">
            <Spinner animation="border" role="status">
              <span className="sr-only">{t("query_loading")}</span>
            </Spinner>
          </div>
        ) : allQR && allQR.length > 0 ? (
          allQR.map((reservation) => (
            <Card key={reservation?._id} className="shadow-sm mb-3">
              <Card.Body>
                <Row className="align-items-center">
                  {/* Text Section */}
                  <Col xs={12} md={8}>
                    <h5>
                      {t("qrc_UID")}: {reservation?.qrc_UID}
                    </h5>
                    <div className="mt-2">
                      {t("category")}:{" "}
                      {formatCategory(reservation?.qrcCategory || reservation?.__t)}
                    </div>
                    <div className="mt-2">
                      {t("content")}:{" "}
                      {reservation?.staticContent ? (
                        <a
                          href={reservation.staticContent}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            wordBreak: "break-all",
                          }}
                        >
                          {reservation.staticContent}
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </Col>

                  {/* QR Image Section */}
                  {reservation?.qrCodeUrl && (
                    <Col
                      xs={12}
                      md={4}
                      className="d-flex justify-content-center justify-content-md-end mt-3 mt-md-0"
                    >
                      <img
                        onClick={() => handleQrClick(reservation?.qrCodeUrl)}
                        src={reservation?.qrCodeUrl}
                        alt="QR Code"
                        style={{
                          width: "120px",
                          height: "120px",
                          cursor: "pointer",
                          objectFit: "contain",
                        }}
                      />
                    </Col>
                  )}
                </Row>
              </Card.Body>
            </Card>
          ))
        ) : (
          <div className="text-center mt-4">{t("no_qrc_list")}</div>
        )}
      </Col>

      {/* QR Popup */}
      <Modal
        size="sm"
        onHide={closeQrPopup}
        show={qrPopupOpen}
        centered
        className="fade"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("qr_code")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img
            src={qrImageUrl}
            alt="QR Code"
            style={{ maxWidth: "200px", height: "auto", marginBottom: "20px" }}
          />
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          {qrImageUrl && (
            <Button
              variant="primary"
              onClick={() => {
                const link = document.createElement("a");
                link.href = qrImageUrl;
                link.download = "QR_Code.png";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              {t("download")}
            </Button>
          )}
          <Button variant="secondary" onClick={closeQrPopup}>
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default AllQRHero;
